import HttpCliente from "../HttpCliente";

/**
 * Login unificado. Intenta primero el login INTERNO (empresa/equipo) contra
 * /Usuario/Login y, si las credenciales no corresponden a un usuario interno,
 * intenta el de SUSCRIPTOR contra /SuscriptorAuth/Login.
 * Devuelve { ok, token } o { ok:false, message }.
 *
 * Llama a los endpoints directamente para controlar el guardado del token
 * (el bug anterior era navegar antes de guardar el token).
 */

// ── Login interno con email + password → /Usuario/Login ──
const loginInterno = async (email, password) => {
  try {
    // Tu backend interno espera { Email, Password } (ver authAction.js)
    const res = await HttpCliente.post(
      "/Usuario/Login",
      { Email: email, Password: password },
      { headers: { "Content-Type": "application/json", Accept: "application/json" } }
    );
    // /Usuario/Login devuelve el token como string directo (response.data)
    const data = res.data;
    const token = typeof data === "string" ? data : (data.token || data.Token);
    if (token) return { ok: true, token };
    return { ok: false, message: "Credenciales inválidas." };
  } catch (err) {
    // 401/400 → no es usuario interno (probaremos suscriptor)
    return {
      ok: false,
      message: err?.response?.data || "Credenciales inválidas.",
      status: err?.response?.status,
    };
  }
};

// ── Login suscriptor con email + password → /SuscriptorAuth/Login ──
const loginSuscriptor = async (email, password) => {
  try {
    const res = await HttpCliente.post(
      "/SuscriptorAuth/Login",
      { email, password },
      { headers: { "Content-Type": "application/json", Accept: "application/json" } }
    );
    const data = res.data;
    if ((data.success ?? data.Success) && (data.token ?? data.Token)) {
      return { ok: true, token: data.token ?? data.Token };
    }
    return { ok: false, message: (data.message ?? data.Message) || "Correo o contraseña incorrectos." };
  } catch (err) {
    const data = err?.response?.data;
    if (data && (data.message || data.Message)) {
      return { ok: false, message: data.message || data.Message };
    }
    return { ok: false, message: "Correo o contraseña incorrectos." };
  }
};

// ── Cascada email + password: interno → suscriptor ──
export const loginUnificado = async (email, password) => {
  const interno = await loginInterno(email, password);
  if (interno.ok) return { ok: true, token: interno.token };

  const susc = await loginSuscriptor(email, password);
  if (susc.ok) return { ok: true, token: susc.token };

  return { ok: false, message: susc.message || interno.message || "Correo o contraseña incorrectos." };
};

// ── Login Google unificado: interno → suscriptor ──
export const loginGoogleUnificado = async (idToken) => {
  // 1) Intento interno → /Usuario/ExternalLogin (body { Provider, IdToken })
  try {
    const res = await HttpCliente.post(
      "/Usuario/ExternalLogin",
      { Provider: "Google", IdToken: idToken },
      { headers: { "Content-Type": "application/json", Accept: "application/json" } }
    );
    const data = res.data;
    const token = typeof data === "string" ? data : (data.token || data.Token);
    if (token) return { ok: true, token };
  } catch {
    // sigue al intento suscriptor
  }

  // 2) Intento suscriptor → /SuscriptorAuth/LoginGoogle (body { idToken })
  try {
    const res = await HttpCliente.post(
      "/SuscriptorAuth/LoginGoogle",
      { idToken },
      { headers: { "Content-Type": "application/json", Accept: "application/json" } }
    );
    const data = res.data;
    if ((data.success ?? data.Success) && (data.token ?? data.Token)) {
      return { ok: true, token: data.token ?? data.Token };
    }
    if (data.noRegistrado ?? data.NoRegistrado) {
      return { ok: false, noRegistrado: true, message: "No estás registrado con este correo." };
    }
    return { ok: false, message: (data.message ?? data.Message) || "No se pudo iniciar sesión con Google." };
  } catch (err) {
    const data = err?.response?.data;
    if (data && (data.noRegistrado || data.NoRegistrado)) {
      return { ok: false, noRegistrado: true, message: "No estás registrado con este correo." };
    }
    return { ok: false, message: "No se pudo iniciar sesión con Google." };
  }
};